module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-checklists/master-checklists.component.scss
// module id = ./src/app/master/master-checklists/master-checklists.component.scss
// module chunks = main